import { FC, useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";

import toast, { Toaster } from "react-hot-toast";
import clsx from "clsx";

import { AppDispatch } from "../../../redux/reducer/store";
import {
  actionGetVacantRoutes,
  actionGetRoutesFilters,
} from "../../../redux/action/projects/actionRoutes";
import { actionGetProjectsList } from "../../../redux/action/projects/actionProjects";
import {
  reducerVacantRoutesInputValues,
  reducerVacantRoutesStatus,
  reducerSetVacantCheckboxes,
  reducerSetVacantListCheckboxes,
  reducerSetVacantListCheckboxesClear,
  reducerSetLimit,
} from "../../../redux/reducer/projects/reducers/reducerVacantRoutesList";
import Loader from "../../custom/loader/loader";
import ToastPopup from "../../custom/toastPopup/toastPopup";
import Pagination from "../../pagination/pagination";
import LimitSelect from "../../custom/limitSelect/limitSelect";
import { generateStyles } from "../../../utils/generateToastStyles";
import CustomMultiSelect from "../../custom/customMultiSelect/customMultiSelect";

import { IProjestListOptions } from "../../../types/projectsInterface";
import { IRoutesOptions } from "../../../types/routeInterfaces";

import "../table.scss";
import styles from "./recruiting.module.scss";
import { IUserOptions } from "../../../types/interfaces";

const IS_VISIBLE_SIDEBAR = process.env.REACT_APP_IS_VISIBLE_SIDEBAR;

const TableVacantRoutes: FC<{ inModal?: boolean }> = ({ inModal }) => {
  const dispatch = useDispatch<AppDispatch>();
  const { data: projects } = useSelector(
    (state: any) => state.projects.projects
  );
  const {
    data,
    limit,
    page,
    count,
    vacantRoutesInputValues,
    vacantCheckboxes,
    vacantRoutesSettings,
    clientsStatus,
    clientsStatusMessage,
    filters,
  } = useSelector((state: any) => state.projects.vacantRoutes);
  const { claims } = useSelector((state: IUserOptions) => state.user.user.data);
  const { isOpenSidebar } = useSelector(
    (state: IUserOptions) => state.user.user
  );
  const [isInputChange, setIsInputChange] = useState<boolean>(false);
  const [currentPage, setCurrentPage] = useState<number>(1);
  const [startPage, setStartPage] = useState<number>(1);
  const [isPending, setIsPending] = useState<boolean>(false);
  const iteral = data;
  useEffect(() => {
    return () => {
      dispatch(reducerSetVacantListCheckboxesClear());
    };
  }, [dispatch]);
  // eslint-disable-next-line
  const actualLimit =
    JSON.parse(localStorage.getItem("pageLimit") as string) || limit;

  const requestStatusOptions = [
    {
      status: 201,
      successMessage: clientsStatusMessage,
    },
    {
      status: 401,
      errorMessage: clientsStatusMessage,
    },
    {
      status: 500,
      errorMessage: "Что-то пошло не так на стороне сервера",
    },
    {
      status: 2,
      errorMessage: "Выберите проект",
    },
    {
      status: 3,
      errorMessage: "Выберите маршрут",
    },
  ];
  useEffect(() => {
    setIsPending(true);
    dispatch(actionGetVacantRoutes(limit, page)).then(() => {
      setIsPending(false);
    });
  }, [dispatch, limit, page]);

  useEffect(() => {
    if (
      inModal &&
      (claims.includes("admin") || claims.includes("projects:list"))
    ) {
      if (projects?.length > 0) {
        const data = projects.map((el: IProjestListOptions) => ({
          id: el.project.id,
          name: el.project.name,
        }));
        dispatch(actionGetRoutesFilters(data));
      }
    } else {
      dispatch(actionGetRoutesFilters(vacantRoutesInputValues.project));
    }
  }, [dispatch, projects, inModal, vacantRoutesInputValues, claims]);

  const resetPages = () => {
    setCurrentPage(1);
    setStartPage(1);
  };
  const handleChange = (newLimit: number, newPage: number) => {
    setIsPending(true);
    dispatch(reducerSetLimit(newLimit));
    dispatch(actionGetVacantRoutes(newLimit, newPage)).then(() => {
      setIsPending(false);
    });
    localStorage.setItem("pageLimit", JSON.stringify(newLimit));
  };
  // eslint-disable-next-line
  const handleChangeLimits = (option: { value: number }) => {
    handleChange(option.value, 1);
    resetPages();
  };
  const handleCBrow = (route: IRoutesOptions) => {
    const updatedVacantCheckboxes = vacantCheckboxes.map(
      (item: IRoutesOptions) => {
        if (
          item.routeNo === route.routeNo &&
          item.project.id === route.project.id
        ) {
          return {
            ...item,
            checked: !item.checked,
          };
        } else {
          return item;
        }
      }
    );
    dispatch(reducerSetVacantCheckboxes(updatedVacantCheckboxes));
    dispatch(reducerSetVacantListCheckboxes(route));
  };
  useEffect(() => {
    if (iteral) {
      const data = iteral.map((item: IRoutesOptions) => {
        return { ...item, checked: false };
      });
      dispatch(reducerSetVacantCheckboxes(data));
    }
  }, [iteral, dispatch]);
  const handleInputChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    const { name, value } = event.target;
    if (value === "") {
      const updatedInputValues = { ...vacantRoutesInputValues };
      updatedInputValues[name] = null;
      dispatch(reducerVacantRoutesInputValues(updatedInputValues));
    } else {
      dispatch(
        reducerVacantRoutesInputValues({
          ...vacantRoutesInputValues,
          [name]: name === "routeNo" ? [value] : value,
        })
      );
    }
    setIsInputChange(true);
  };
  const handleKeyPress = (event: React.KeyboardEvent<HTMLInputElement>) => {
    if (event.key === "Enter") {
      setIsPending(true);
      dispatch(actionGetVacantRoutes(limit, page)).then(() => {
        setIsPending(false);
      });
      setIsInputChange(false);
      resetPages();
    }
  };
  const handleFromFilter = (
    event: React.ChangeEvent<HTMLInputElement>,
    name: string
  ) => {
    const value = event.target.value;
    if (value === "") {
      const updatedInputValues = { ...vacantRoutesInputValues };
      updatedInputValues[name] = {
        ...vacantRoutesInputValues[name],
        from: null,
      };
      dispatch(reducerVacantRoutesInputValues(updatedInputValues));
    } else {
      dispatch(
        reducerVacantRoutesInputValues({
          ...vacantRoutesInputValues,
          [name]: { ...vacantRoutesInputValues[name], from: value },
        })
      );
    }
    setIsInputChange(true);
  };
  const handleToFilter = (
    event: React.ChangeEvent<HTMLInputElement>,
    name: string
  ) => {
    const value = event.target.value;
    if (value === "") {
      const updatedInputValues = { ...vacantRoutesInputValues };
      updatedInputValues[name] = { ...vacantRoutesInputValues[name], to: null };
      dispatch(reducerVacantRoutesInputValues(updatedInputValues));
    } else {
      dispatch(
        reducerVacantRoutesInputValues({
          ...vacantRoutesInputValues,
          [name]: { ...vacantRoutesInputValues[name], to: value },
        })
      );
    }
    setIsInputChange(true);
  };
  const getRowClassName = (route: IRoutesOptions) => {
    const statusObject = route?.routeStatusType;
    if (statusObject) {
      const statusKey = Object.keys(statusObject)[0];
      if (statusKey === "VacantNoVacancy") {
        return "red__row";
      } else if (statusKey === "ReplacementNoVacancy") {
        return "yellow__row";
      } else if (statusKey === "ActiveNoVacancy") {
        return "lightBlue__row";
      } else if (
        Object.keys(route?.status)[0] !== "Vacation" ||
        Object.keys(route?.status)[0] !== "OutSick"
      ) {
        return "white__row";
      }
    }
  };

  const renderVisibleRows = () => {
    const visibleRows: JSX.Element[] = [];
    for (let i = 0; i < iteral?.length; i++) {
      const route = iteral[i];
      const foundElement = vacantCheckboxes.find(
        (item: IRoutesOptions) =>
          item.routeNo === route.routeNo && item.project.id === route.project.id
      );
      if (route !== undefined) {
        visibleRows.push(
          <tr
            className={clsx("active__link_tr", getRowClassName(route))}
            key={`${i}+${route.routeNo}`}
          >
            <td>
              <input
                checked={foundElement?.checked ? foundElement.checked : false}
                onChange={() => handleCBrow(route)}
                className="relative__elem"
                type="checkbox"
                disabled={
                  claims.includes("admin") ||
                  claims.includes("recruiting:vacancy:edit")
                    ? !getRowClassName(route) || !route.canBeAttachedToVacancy
                    : true
                }
              />
            </td>

            {(claims.includes("admin") || claims.includes("projects:list")) &&
              vacantRoutesSettings.includes("project") && (
                <td style={{ minWidth: "180px" }}>
                  <span className="relative__elem">{route?.project.name}</span>
                </td>
              )}

            {vacantRoutesSettings.includes("routeNo") && (
              <td>
                <span className="relative__elem">{route.routeNo}</span>
              </td>
            )}

            {vacantRoutesSettings.includes("login") && (
              <td>
                <span className="relative__elem">{route.login}</span>
              </td>
            )}

            {vacantRoutesSettings.includes("routeType") && (
              <td style={{ minWidth: "180px" }}>
                <span className="relative__elem">
                  {route.routeStatusType &&
                    Object.values(route.routeStatusType)}
                </span>
              </td>
            )}

            {vacantRoutesSettings.includes("vacancyName") && (
              <td>
                <span className="relative__elem">
                  <a
                    href={`/recruiting/vacancy/${route?.vacancy?.id}`}
                    className="report__link"
                  >
                    {route?.vacancy?.name}
                  </a>
                </span>
              </td>
            )}

            {vacantRoutesSettings.includes("vsv") && (
              <td style={{ minWidth: "280px" }}>
                <span className="relative__elem">{route.vsv}</span>
              </td>
            )}

            {vacantRoutesSettings.includes("supervisor") && (
              <td style={{ minWidth: "280px" }}>
                <span className="relative__elem">{route.sv}</span>
              </td>
            )}

            {vacantRoutesSettings.includes("tt") && (
              <td>
                <span className="relative__elem">{route.places}</span>
              </td>
            )}

            {vacantRoutesSettings.includes("visitsOnWeek") && (
              <td>
                <span className="relative__elem">{route.visitsPlan}</span>
              </td>
            )}

            {vacantRoutesSettings.includes("income") && (
              <td>
                <span className="relative__elem">{route.income}</span>
              </td>
            )}

            {vacantRoutesSettings.includes("plannedWage") && (
              <td>
                <span className="relative__elem">{route.plannedWage}</span>
              </td>
            )}
          </tr>
        );
      }
    }

    return visibleRows;
  };
  useEffect(() => {
    requestStatusOptions.forEach(
      (option: {
        status: number;
        successMessage?: string;
        errorMessage?: string;
      }) => {
        if (clientsStatus === option.status) {
          toast.dismiss();

          toast(
            (t) => (
              <ToastPopup
                title={
                  option.successMessage
                    ? option.successMessage
                    : option.errorMessage
                }
                isSuccess={!!option.successMessage}
                toast={toast}
                t={t}
              />
            ),
            generateStyles(!!option.successMessage)
          );
        }
      }
    );

    setTimeout(() => {
      dispatch(reducerVacantRoutesStatus(null));
    }, 5000);
    // eslint-disable-next-line
  }, [dispatch, clientsStatus]);
  useEffect(() => {
    const handleDocumentClick = (
      event: React.ChangeEvent<HTMLInputElement> | Event
    ): void => {
      const inputEvent = event as React.ChangeEvent<HTMLInputElement>;
      const inputsNames = ["income", "planVisits", "wage", "posNum"];
      if (!inputsNames.includes(inputEvent.target.name)) {
        setIsPending(true);
        dispatch(actionGetVacantRoutes(limit, page)).then(() => {
          setIsPending(false);
        });
        setIsInputChange(false);
        resetPages();
      }
    };
    if (isInputChange) {
      document.addEventListener("click", handleDocumentClick);
      return () => {
        document.removeEventListener("click", handleDocumentClick);
      };
    } else
      return () => {
        document.removeEventListener("click", handleDocumentClick);
      };
  }, [dispatch, isInputChange, limit, page]);
  useEffect(() => {
    if (claims.includes("admin") || claims.includes("projects:list")) {
      dispatch(actionGetProjectsList(actualLimit, page));
    }
  }, [actualLimit, dispatch, page, claims]);

  return (
    <>
      <div className="loader__wrapper">{isPending && <Loader />}</div>

      <div
        className={clsx(
          JSON.parse(IS_VISIBLE_SIDEBAR as string) &&
            isOpenSidebar &&
            "active__table",
          !isOpenSidebar && "closed__table",
          "table"
        )}
      >
        {clientsStatus && clientsStatus !== null && (
          <Toaster position="top-center" toastOptions={{ duration: 1500 }} />
        )}

        <div className="filters__container__mobile">
          {vacantRoutesSettings.includes("project") &&
            (claims.includes("admin") || claims.includes("projects:list")) && (
              <div className="filters__item__mobile">
                <div className="reports__region_block">
                  <CustomMultiSelect
                    setLoading={setIsPending}
                    reducer={reducerVacantRoutesInputValues}
                    inputValues={vacantRoutesInputValues}
                    action={actionGetVacantRoutes}
                    options={filters.project}
                    isShowPlaceholder={true}
                    resetPages={resetPages}
                    pageName="type2"
                    placeholder="Проект"
                    name="project"
                    limit={limit}
                  />
                </div>
              </div>
            )}

          {vacantRoutesSettings.includes("routeNo") && (
            <div className="filters__item__mobile">
              <div className="filter__number_block">
                <input
                  defaultValue={
                    vacantRoutesInputValues.routeNo &&
                    vacantRoutesInputValues.routeNo
                  }
                  onChange={handleInputChange}
                  onKeyPress={handleKeyPress}
                  name="routeNo"
                  placeholder=" "
                  type="number"
                />
                <label>№</label>
              </div>
            </div>
          )}
          {vacantRoutesSettings.includes("login") && (
            <div className="filters__item__mobile filters__item__mobile--full">
              <div className="routes__multiselect_block">
                <CustomMultiSelect
                  setLoading={setIsPending}
                  reducer={reducerVacantRoutesInputValues}
                  inputValues={vacantRoutesInputValues}
                  action={actionGetVacantRoutes}
                  options={filters.merch}
                  activeOptions={vacantRoutesInputValues.merch}
                  isShowPlaceholder={true}
                  resetPages={resetPages}
                  pageName="type2"
                  placeholder="Логин/Локация"
                  name="merch"
                  limit={limit}
                />
              </div>
            </div>
          )}

          {vacantRoutesSettings.includes("routeType") && (
            <div className="filters__item__mobile filters__item__mobile--full">
              <div className="routes__multiselect_block">
                <CustomMultiSelect
                  setLoading={setIsPending}
                  reducer={reducerVacantRoutesInputValues}
                  inputValues={vacantRoutesInputValues}
                  action={actionGetVacantRoutes}
                  options={filters.routeStatusType}
                  isShowPlaceholder={true}
                  resetPages={resetPages}
                  pageName="type1"
                  placeholder="Тип маршрута"
                  name="routeStatusType"
                  limit={limit}
                />
              </div>
            </div>
          )}

          {vacantRoutesSettings.includes("vacancyName") && (
            <div className="filters__item__mobile filters__item__mobile--full">
              <div className="filter__block">
                <input
                  onChange={handleInputChange}
                  onKeyPress={handleKeyPress}
                  autoComplete="off"
                  placeholder=" "
                  name="name"
                  type="text"
                />
                <label>Название вакансии</label>
              </div>
            </div>
          )}

          {vacantRoutesSettings.includes("vsv") && (
            <div className="filters__item__mobile">
              <div className="routes__multiselect_block">
                <CustomMultiSelect
                  setLoading={setIsPending}
                  reducer={reducerVacantRoutesInputValues}
                  inputValues={vacantRoutesInputValues}
                  action={actionGetVacantRoutes}
                  options={filters.vSupervisor}
                  isShowPlaceholder={true}
                  resetPages={resetPages}
                  pageName="type2"
                  placeholder="ВСВ"
                  name="vsv"
                  limit={limit}
                />
              </div>
            </div>
          )}

          {vacantRoutesSettings.includes("supervisor") && (
            <div className="filters__item__mobile">
              <div className="routes__multiselect_block">
                <CustomMultiSelect
                  setLoading={setIsPending}
                  reducer={reducerVacantRoutesInputValues}
                  inputValues={vacantRoutesInputValues}
                  action={actionGetVacantRoutes}
                  options={filters.supervisor}
                  isShowPlaceholder={true}
                  resetPages={resetPages}
                  pageName="routes"
                  placeholder="Супервайзер"
                  name="sv"
                  limit={limit}
                />
              </div>
            </div>
          )}

          {vacantRoutesSettings.includes("tt") && (
            <div className="filters__item__mobile filters__item__mobile--full">
              <div className={styles.fromToFilter}>
                <span className={styles.widthSpan}>Кол-во ТТ на маршруте</span>
                <div className={styles.filterNumberBlock + ' filter__number_block'}>
                  <input
                    onChange={(event) => handleFromFilter(event, "posNum")}
                    onKeyPress={handleKeyPress}
                    name="posNum"
                    placeholder=" "
                    type="number"
                  />
                  <label>От</label>
                </div>
                <div className={styles.filterNumberBlock + ' filter__number_block'}>
                  <input
                    onChange={(event) => handleToFilter(event, "posNum")}
                    onKeyPress={handleKeyPress}
                    name="posNum"
                    placeholder=" "
                    type="number"
                  />
                  <label>До</label>
                </div>
              </div>
            </div>
          )}

          {vacantRoutesSettings.includes("visitsOnWeek") && (
            <div className="filters__item__mobile filters__item__mobile--full">
              <div className={styles.fromToFilter}>
                <span className={styles.widthSpan}>
                  Плановое кол-во визитов в неделю
                </span>
                <div className={styles.filterNumberBlock + ' filter__number_block'}>
                  <input
                    onChange={(event) => handleFromFilter(event, "planVisits")}
                    onKeyPress={handleKeyPress}
                    name="planVisits"
                    placeholder=" "
                    type="number"
                  />
                  <label>От</label>
                </div>
                <div className={styles.filterNumberBlock + ' filter__number_block'}>
                  <input
                    onChange={(event) => handleToFilter(event, "planVisits")}
                    onKeyPress={handleKeyPress}
                    name="planVisits"
                    placeholder=" "
                    type="number"
                  />
                  <label>До</label>
                </div>
              </div>
            </div>
          )}

          {vacantRoutesSettings.includes("income") && (
            <div className="filters__item__mobile filters__item__mobile--full">
              <div className={styles.fromToFilter}>
                <span className={styles.widthSpan}>Выручка</span>
                <div className={styles.filterNumberBlock + ' filter__number_block'}>
                  <input
                    onChange={(event) => handleFromFilter(event, "income")}
                    onKeyPress={handleKeyPress}
                    name="income"
                    placeholder=" "
                    type="number"
                  />
                  <label>От</label>
                </div>
                <div className={styles.filterNumberBlock + ' filter__number_block'}>
                  <input
                    onChange={(event) => handleToFilter(event, "income")}
                    onKeyPress={handleKeyPress}
                    name="income"
                    placeholder=" "
                    type="number"
                  />
                  <label>До</label>
                </div>
              </div>
            </div>
          )}

          {vacantRoutesSettings.includes("plannedWage") && (
            <div className="filters__item__mobile filters__item__mobile--full">
              <div className={styles.fromToFilter}>
                <span className={styles.widthSpan}>Зарплата</span>
                <div className={styles.filterNumberBlock + ' filter__number_block'}>
                  <input
                    onChange={(event) => handleFromFilter(event, "wage")}
                    onKeyPress={handleKeyPress}
                    name="wage"
                    placeholder=" "
                    type="number"
                  />
                  <label>От</label>
                </div>
                <div className={styles.filterNumberBlock + ' filter__number_block'}>
                  <input
                    onChange={(event) => handleToFilter(event, "wage")}
                    onKeyPress={handleKeyPress}
                    name="wage"
                    placeholder=" "
                    type="number"
                  />
                  <label>До</label>
                </div>
              </div>
            </div>
          )}
        </div>

        <div
          className={clsx(
            inModal ? "table__wrapper-inModal" : "table__wrapper"
          )}
        >
          <table>
            <thead className="table__header__filters">
              <tr>
                <th className="reports__checkbox_block"></th>

                {vacantRoutesSettings.includes("project") &&
                  (claims.includes("admin") ||
                    claims.includes("projects:list")) && (
                    <th>
                      <div className="reports__region_block">
                        <CustomMultiSelect
                          setLoading={setIsPending}
                          reducer={reducerVacantRoutesInputValues}
                          inputValues={vacantRoutesInputValues}
                          action={actionGetVacantRoutes}
                          options={filters.project}
                          isShowPlaceholder={true}
                          resetPages={resetPages}
                          pageName="type2"
                          placeholder="Проект"
                          name="project"
                          limit={limit}
                        />
                      </div>
                    </th>
                  )}

                {vacantRoutesSettings.includes("routeNo") && (
                  <th className="filter__number_block">
                    <div>
                      <input
                        defaultValue={
                          vacantRoutesInputValues.routeNo &&
                          vacantRoutesInputValues.routeNo
                        }
                        onChange={handleInputChange}
                        onKeyPress={handleKeyPress}
                        name="routeNo"
                        placeholder=" "
                        type="number"
                      />
                      <label>№</label>
                    </div>
                  </th>
                )}
                {vacantRoutesSettings.includes("login") && (
                  <th style={{ minWidth: "280px" }}>
                    <div className="routes__multiselect_block">
                      <CustomMultiSelect
                        setLoading={setIsPending}
                        reducer={reducerVacantRoutesInputValues}
                        inputValues={vacantRoutesInputValues}
                        action={actionGetVacantRoutes}
                        options={filters.merch}
                        activeOptions={vacantRoutesInputValues.merch}
                        isShowPlaceholder={true}
                        resetPages={resetPages}
                        pageName="type2"
                        placeholder="Логин/Локация"
                        name="merch"
                        limit={limit}
                      />
                    </div>
                  </th>
                )}

                {vacantRoutesSettings.includes("routeType") && (
                  <th>
                    <div className="routes__multiselect_block">
                      <CustomMultiSelect
                        setLoading={setIsPending}
                        reducer={reducerVacantRoutesInputValues}
                        inputValues={vacantRoutesInputValues}
                        action={actionGetVacantRoutes}
                        options={filters.routeStatusType}
                        isShowPlaceholder={true}
                        resetPages={resetPages}
                        pageName="type1"
                        placeholder="Тип маршрута"
                        name="routeStatusType"
                        limit={limit}
                      />
                    </div>
                  </th>
                )}

                {vacantRoutesSettings.includes("vacancyName") && (
                  <th style={{ minWidth: "180px" }}>
                    <div className="filter__block">
                      <input
                        onChange={handleInputChange}
                        onKeyPress={handleKeyPress}
                        autoComplete="off"
                        placeholder=" "
                        name="name"
                        type="text"
                      />
                      <label>Название вакансии</label>
                    </div>
                  </th>
                )}

                {vacantRoutesSettings.includes("vsv") && (
                  <th>
                    <div className="routes__multiselect_block">
                      <CustomMultiSelect
                        setLoading={setIsPending}
                        reducer={reducerVacantRoutesInputValues}
                        inputValues={vacantRoutesInputValues}
                        action={actionGetVacantRoutes}
                        options={filters.vSupervisor}
                        isShowPlaceholder={true}
                        resetPages={resetPages}
                        pageName="type2"
                        placeholder="ВСВ"
                        name="vsv"
                        limit={limit}
                      />
                    </div>
                  </th>
                )}

                {vacantRoutesSettings.includes("supervisor") && (
                  <th>
                    <div className="routes__multiselect_block">
                      <CustomMultiSelect
                        setLoading={setIsPending}
                        reducer={reducerVacantRoutesInputValues}
                        inputValues={vacantRoutesInputValues}
                        action={actionGetVacantRoutes}
                        options={filters.supervisor}
                        isShowPlaceholder={true}
                        resetPages={resetPages}
                        pageName="routes"
                        placeholder="Супервайзер"
                        name="sv"
                        limit={limit}
                      />
                    </div>
                  </th>
                )}

                {vacantRoutesSettings.includes("tt") && (
                  <th>
                    <div className={styles.fromToFilter}>
                      <span className={styles.widthSpan}>
                        Кол-во ТТ на маршруте
                      </span>
                      <div className="filter__number_block">
                        <input
                          onChange={(event) =>
                            handleFromFilter(event, "posNum")
                          }
                          onKeyPress={handleKeyPress}
                          name="posNum"
                          placeholder=" "
                          type="number"
                        />
                        <label>От</label>
                      </div>
                      <div className="filter__number_block">
                        <input
                          onChange={(event) => handleToFilter(event, "posNum")}
                          onKeyPress={handleKeyPress}
                          name="posNum"
                          placeholder=" "
                          type="number"
                        />
                        <label>До</label>
                      </div>
                    </div>
                  </th>
                )}

                {vacantRoutesSettings.includes("visitsOnWeek") && (
                  <th>
                    <div className={styles.fromToFilter}>
                      <span className={styles.widthSpan}>
                        Плановое кол-во визитов в неделю
                      </span>
                      <div className="filter__number_block">
                        <input
                          onChange={(event) =>
                            handleFromFilter(event, "planVisits")
                          }
                          onKeyPress={handleKeyPress}
                          name="planVisits"
                          placeholder=" "
                          type="number"
                        />
                        <label>От</label>
                      </div>
                      <div className="filter__number_block">
                        <input
                          onChange={(event) =>
                            handleToFilter(event, "planVisits")
                          }
                          onKeyPress={handleKeyPress}
                          name="planVisits"
                          placeholder=" "
                          type="number"
                        />
                        <label>До</label>
                      </div>
                    </div>
                  </th>
                )}

                {vacantRoutesSettings.includes("income") && (
                  <th>
                    <div className={styles.fromToFilter}>
                      <span>Выручка</span>
                      <div className="filter__number_block">
                        <input
                          onChange={(event) =>
                            handleFromFilter(event, "income")
                          }
                          onKeyPress={handleKeyPress}
                          name="income"
                          placeholder=" "
                          type="number"
                        />
                        <label>От</label>
                      </div>
                      <div className="filter__number_block">
                        <input
                          onChange={(event) => handleToFilter(event, "income")}
                          onKeyPress={handleKeyPress}
                          name="income"
                          placeholder=" "
                          type="number"
                        />
                        <label>До</label>
                      </div>
                    </div>
                  </th>
                )}

                {vacantRoutesSettings.includes("plannedWage") && (
                  <th>
                    <div className={styles.fromToFilter}>
                      <span>Зарплата</span>
                      <div className="filter__number_block">
                        <input
                          onChange={(event) => handleFromFilter(event, "wage")}
                          onKeyPress={handleKeyPress}
                          name="wage"
                          placeholder=" "
                          type="number"
                        />
                        <label>От</label>
                      </div>
                      <div className="filter__number_block">
                        <input
                          onChange={(event) => handleToFilter(event, "wage")}
                          onKeyPress={handleKeyPress}
                          name="wage"
                          placeholder=" "
                          type="number"
                        />
                        <label>До</label>
                      </div>
                    </div>
                  </th>
                )}
              </tr>
            </thead>
            <tbody>{renderVisibleRows()}</tbody>
          </table>
          {(data === undefined || (data && data.length === 0)) && (
            <div className={styles.noData}>Нет данных</div>
          )}
        </div>

        <div className="pagination">
          <div className="pagination__count">Всего: {count}</div>
          <div className="pagination__str">
            <span>Отображать строки</span>
            <LimitSelect limit={actualLimit} propsChange={handleChangeLimits} />
          </div>
          <Pagination
            setCurrentPage={setCurrentPage}
            setStartPage={setStartPage}
            handleChange={handleChange}
            count={count}
            currentPage={currentPage}
            startPage={startPage}
            limit={actualLimit}
            pageName="userReports"
          />
        </div>
      </div>
    </>
  );
};

export default TableVacantRoutes;
